// extracted by mini-css-extract-plugin
export default {"chatControls":"ChatControls_chatControls__sa3cI"};